import { render, staticRenderFns } from "./ModalLeaderBoard.vue?vue&type=template&id=3303788c&"
import script from "./ModalLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./ModalLeaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports